<template>
    <div>
        <!--提示标题栏-->
        <div style="width: 88%;height: 40px;line-height:40px;">
            <div style="
            background-color: #adadad;
            width: 150px;
            height: 40px;
            text-align: center;
            vertical-align: middle;
            float: left;">
                派样活动配置
            </div>
            <div style="
            background-color: #adadad;
            margin-left: 2px;
            width: 35%;
            height: 40px;
            text-align: center;
            color: #adadad;
            float: left;">
                派样活动配置
            </div>
        </div>
        <!--派样活动配置-->
        <div>
            <el-form :model="ecxForm" :rules="actrules" ref="ecxForm"
                     label-width="150px" class="demo-ruleForm">
                <el-form-item label="选择提货码活动" prop="choiceActExcode">
                    <el-input v-model="ecxForm.choiceActExcode" placeholder="应用编号"
                              style="width: 20%;"
                              maxlength="80"
                              :disabled="ecxForm.isModifiable">
                    </el-input>
                </el-form-item>
                <!--上一步按钮 下一步按钮-->
                <el-form-item style="margin-top: 10%;margin-left: 16.5%;">
                    <el-button type="primary" @click="lastStep('ecxForm')"
                               id="last_step">上一步
                    </el-button>
                    <el-button type="primary" @click="saveData('ecxForm')"
                               id="save" v-show="isSave">保存
                    </el-button>
                    <el-button type="primary" @click="saveOrUpdate('ecxForm')"
                               id="save_update" v-show="isSaveUpdate">保存修改
                    </el-button>
                    <el-button type="primary" @click="submitData('ecxForm')"
                               id="submit" v-show="isSubmit">提交
                    </el-button>
                    <el-button type="primary" @click="nextStep('ecxForm')"
                               id="next_step" v-show="isNextStep">下一步
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SamplingFragment",
        props: ["actId", "actStatus", "actStatus2"],
        data() {
            return {
                isSave: false,
                isSubmit: false,
                isSave: false,
                isSaveUpdate: false,
                isNextStep: false,
                prodindex: 0,
                acts: [],
                tenantId: '',
                appType: 'delivery',
                ecxForm: {
                    choiceActExcode: '',
                    isModifiable: false,
                },
                actrules: {
                    choiceActExcode: [
                        {required: true, message: '请输入应用编号', trigger: 'blur'},
                    ],

                },
            }
        },
        created() {
            this.tenantId = this.getcookie("storeId");
            console.log("派样配置：" + this.actId + "--" + this.editer)
            if (this.actStatus == "1") {
                if (this.actStatus2 == "-1") {
                    this.ecxForm.isModifiable = false;
                    this.isSave = false,
                    this.isSubmit = true,
                    this.isSaveUpdate = true,
                    this.isNextStep = false
                } else {
                    this.ecxForm.isModifiable = false;
                    this.isSave = false,
                    this.isSubmit = false,
                    this.isSaveUpdate = true,
                    this.isNextStep = false
                }
                this.getAppType()
            } else if (this.actStatus == "2") {
                this.ecxForm.isModifiable = true;
                this.isSave = false,
                    this.isSubmit = false,
                    this.isSaveUpdate = false,
                    this.isNextStep = true,
                    this.getAppType()
            } else {
                this.ecxForm.isModifiable = false;
                this.isSave = true,
                    this.isSubmit = true,
                    this.isSaveUpdate = false,
                    this.isNextStep = false
            }
        },
        methods: {
            /*保存按钮*/
            saveData(formName) {
                this.addApp(1)
            },
            /*提交按钮*/
            submitData(formName) {
                if (this.ecxForm.choiceActExcode + "" === "") {
                    this.$message({showClose: true, message: '请输入应用编号', type: 'error'});
                    return false;
                }
                this.updateStatus(1)

            },
            /*保存修改按钮*/
            saveOrUpdate(formName) {
                if (this.ecxForm.choiceActExcode + "" === "") {
                    this.$message({showClose: true, message: '请输入应用编号', type: 'error'});
                    return false;
                }
                this.checkAppId()
            },
            /*新增应用信息 --1.直接添加；2.修改添加*/
            addApp(flag) {
                if (this.ecxForm.choiceActExcode + "" === "") {
                    this.$message({showClose: true, message: '请输入应用编号', type: 'error'});
                    return false;
                }
                //数据请求
                this.loading = true
                var params = {
                    appId: this.ecxForm.choiceActExcode, appTypeId: this.appType,
                    actId: this.actId, /*tenantId: this.tenantId*/
                };
                //异步请求
                this.$http.post(this.actManagerHost + this.addAppInfoURL, params)
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code == "200") {
                                this.ecxForm.isModifiable = true;
                                if (flag == "1") {

                                } else if (flag == "2") {
                                    if (this.actStatus2 == "-1") {

                                    }else{
                                        this.updateStatus(1)
                                    }
                                }
                                this.$message({showClose: true, message: '添加成功', type: 'success'});
                            } else {
                                this.$message({showClose: true, message: response.body.Meta, type: 'error'});
                            }
                        }
                    }, function (response) {
                        this.$message({showClose: true, message: '网络异常', type: 'error'});
                    })
            },
            /*修改应用信息*/
            updateApp() {
                if (this.ecxForm.choiceActExcode + "" === "") {
                    this.$message({showClose: true, message: '请输入应用编号', type: 'error'});
                    return false;
                }
                //数据请求
                this.loading = true
                var params = {
                    appId: this.ecxForm.choiceActExcode, appTypeId: this.appType,
                    actId: this.actId, /*tenantId: this.tenantId*/
                };
                console.log(params)
                //异步请求
                this.$http.post(this.actManagerHost + this.updateAppInfoURL, params)
                    .then(response => {
                        if (response.status === 200) {
                            console.log(response.body.Code)
                            if (response.body.Code == "200") {
                                this.ecxForm.isModifiable = true;
                                this.$message({showClose: true, message: '修改成功', type: 'success'});
                                if (this.actStatus2 == "-1") {

                                }else{
                                    this.updateStatus(1)
                                }
                            } else {
                                this.$message({showClose: true, message: response.body.Meta, type: 'error'});
                            }
                        }
                    }, function (response) {
                        this.$message({showClose: true, message: '网络异常', type: 'error'});
                    })
            },
            /*卡片跳转*/
            sendMsgToParent: function (step, id) {
                this.$emit("listenToChildEventDef", step, id)
            },
            nextStep() {
                this.sendMsgToParent("5", this.ecxForm.choiceActExcode)
            },
            lastStep() {
                this.sendMsgToParent("3", this.actId)
            },
            /*根据活动编号查询应用信息*/
            getAppType: function () {
                var url = this.actManagerHost + this.findAppInfoURL
                this.$http.get(url + "?actId=" + this.actId)
                    .then(response => {
                        // console.log(response.body)
                        if (response.body.Code === "200") {
                            this.ecxForm.choiceActExcode = response.body.Data.appId;
                        } else {
                            this.$message({showClose: true, message: '操作异常', type: 'error'});
                        }
                    }, function (response) {
                        this.$message({showClose: true, message: '网络异常', type: 'error'});
                    })
            },
            /*根据活动编号查询应用信息*/
            checkAppId() {
                var url = this.actManagerHost + this.findAppInfoURL
                this.$http.get(url + "?actId=" + this.actId)
                    .then(response => {
                        // console.log(response.body)
                        if (response.body.Code === "200") {
                            var id = response.body.Data.appId;
                            if (id === '') {
                                this.addApp(2)
                            } else {
                                this.updateApp()
                            }
                        } else {
                            this.$message({showClose: true, message: '操作异常', type: 'error'});
                        }
                    }, function (response) {
                        this.$message({showClose: true, message: '网络异常', type: 'error'});
                    })
            },
            /*修改活动状态*/
            updateStatus(status) {
                //数据请求
                this.loading = true
                var params = {actStatus: status, actId: this.actId};
                //异步请求
                this.$http.post(this.admin_host + "/admin/activity/modify/status", params)
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code == "200") {
                                if (status == 0) {
                                    this.$message({showClose: true, message: '暂停成功', type: 'success'});
                                } else if (status == 1) {
                                    this.$message({showClose: true, message: '开启成功', type: 'success'});
                                    this.sendMsgToParent("5", this.ecxForm.choiceActExcode)
                                }
                            } else {
                                this.$message({showClose: true, message: response.body.Meta, type: 'error'});
                            }
                        }
                    }, function (response) {
                        console.log("fail")
                        this.$message({showClose: true, message: '网络异常', type: 'error'});
                    })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SamplingFragment.vue?163366dc